module.exports = __webpack_public_path__ + "img/partner13.d7efc0e9.png";